// extracted by mini-css-extract-plugin
export var attachment = "_qk-a";
export var emailContainer = "_qk-4";
export var emailContentPaddedContainer = "_qk-b";
export var emailHeader = "_qk-6";
export var emailIframe = "_qk-3";
export var emailInfoIcon = "_qk-9";
export var emailShortenedSummary = "_qk-e";
export var infoDropdown = "_qk-0";
export var infoRowBoundedContent = "_qk-d";
export var internal = "_qk-5";
export var merchant = "_qk-8";
export var messageInputContainer = "_qk-h";
export var normal = "_qk-7";
export var replyCard = "_qk-f";
export var subtleButton = "_qk-1";
export var subtleButtonIconContainer = "_qk-2";
export var toggleViewRepliesButton = "_qk-c";
export var wrappingText = "_qk-g";